import LargeBox from './LargeBox';

export default LargeBox;
